const hasDuplicates = require("../duplicates/index");

const isValidEmail = (email='') => {
  const regExp = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  const regExpDomain = /[^\@][a-zA-Z0-9$&+,;=?#|'<>.^*()%!-]+$/ig
  const domain = email.match(regExpDomain) ?? ""

  if(domain.toString().length > 0 && hasDuplicates(domain.toString().split("."))){
    return false
  }

  if (email.indexOf('@-') > 0) {
    return false
  }

  return regExp.test(email);
         
}

module.exports = isValidEmail